import { getObj } from '@/api/exam/course'
import { setStore, getStore } from '@/utils/store'

const playerShow = {
  state: {
    playerShow: getStore({
      name: 'playerShow'
    }) || {}
  },
  actions: {
  },
  mutations: {
    updatePlayerShow: (state, view) => {
      state.playerShow = view;
    },
  }
}

export default playerShow



// WEBPACK FOOTER //
// ./src/store/modules/player.js